import React from 'react';

import authService from '../../services/authService';
import routes from '../../utils/routes';

const Logout: React.FC = (): null => {
	React.useEffect(() => {
		authService.logout();

		window.location.href = routes.login.fullPath;
	}, []);

	return null;
};

export default Logout;
